<template>
  <div class="row p-3 mb-0">
    <nav class="col-md-6 mb-md-3">
      <div class="form-row align-items-center justify-content-center-md">
          <div class="col-auto">
              <label class="mr-sm-2 sr-only" for="inlineFormCustomSelect">
                  Registros por página
              </label>
              <input class="form-control" type="number" v-model="pagination.per_page" style="width: 80px;" min="0" @change="changePerPage">
          </div>
          <div class="col-auto">
              <label>Registros por página</label>
          </div>
      </div>
    </nav>
    <nav aria-label="Page navigation" class="col-md-6">
      <ul class="pagination float-md-right justify-content-center-md mb-0">
        <li class="page-item" v-if="pagination.current_page > 1">
          <a href="javascript:void(0)" aria-label="Previous" class="page-link" v-on:click.prevent="changePage(pagination.current_page - 1)">
            <i class="material-icons">chevron_left</i>
          </a>
        </li>
        <li class="page-item" v-for="page in pagesNumber" :class="{'active': page == pagination.current_page}">
          <a class="page-link" href="#" v-on:click.prevent="changePage(page)" v-text="page"></a>
        </li>
        <li class="page-item" v-if="pagination.current_page < pagination.last_page">
          <a href="javascript:void(0)" aria-label="Next" class="page-link" v-on:click.prevent="changePage(pagination.current_page + 1)">
            <i class="material-icons">chevron_right</i>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
  export default{
    props: {
      pagination: {
        type: Object,
        required: true
      },
      offset: {
        type: Number,
        default: 4
      }
    },

    computed: {
      pagesNumber() {
        if (!this.pagination.to) {
          return []
        }
        
        let from = this.pagination.current_page - this.offset
        if (from < 1) {
          from = 1
        }
        let to = from + (this.offset * 2)
        if (to >= this.pagination.last_page) {
          to = this.pagination.last_page
        }
        let pagesArray = []
        for (let page = from; page <= to; page++) {
          pagesArray.push(page)
        }
          return pagesArray
      },
    },
    methods : {
      changePage(page) {
        this.pagination.current_page = page
        this.$emit('paginate')
      },
      changePerPage: function(){
        console.log('pruebas')
        //this.pagination.per_page = this.per_page
        this.$emit('paginate')
      }
    }
  }
</script>